<template>
    <div :class="changeColor?'title color':'title'" >
        <div :class="showIcon?'first titleClick': 'first'" @click="tabTitle()">{{firstName}} <i class="el-icon-arrow-down" v-show="showIcon" ></i></div>
        <div class="last">{{lastName}}</div>
    </div>
</template>

<script>
export default {
    props:{
        firstName:String,     // 头部名字
        lastName:String,      // 英文名字
        showIcon:Boolean,     // 是否显示切换下标
        changeColor:Boolean,  // 标题的青色版本
    },
    data(){
        return{

        }
    },
    methods:{
        tabTitle(){
            if(this.showIcon){
                this.$emit('changeTitle')
            }else{
                return
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .title{
        width: 20vw;
        height: 4.5vh;
        background: url(../../assets/img/titban.png);
        background-size: 100% 100%;
        margin-bottom: 4rem;
        padding:0.75vh 0 0 0.8vw;
        .first{
            display: inline-block;
            font-size: 16rem;
            color: rgba(230,243,253, 1);
        }
        .last{
            font-size: 12rem;
            color: rgba(230,243,253, 0.7);
        }
    }

    .color{
        .first{
            color: #00DEFF;
        }
        .last{
            color: #00DEFF;
        }
    }

    .titleClick{
        cursor: pointer;
    }
</style>